export default __webpack_public_path__ + "static/media/GrisroNimrod.41fcfd5e.jpg";